import {
  type EdgeId,
  type NodeId,
  isPathLookupEdgeData,
} from '@ipfabric/utils';
import {
  type GraphState,
  isPathLookupGraphMetadata,
} from 'components/Graph/GraphState';
import { array } from 'fp-ts';

export const getIncomingEdgeIds = (
  graphState: GraphState,
  outgoingEdgeId: EdgeId,
  nodeId?: NodeId,
): EdgeId[] | undefined => {
  if (nodeId === undefined) {
    return [];
  }
  const { graphMetadata } = graphState;
  const decisions = isPathLookupGraphMetadata(graphMetadata)
    ? graphMetadata.decisions
    : null;
  const decision = decisions?.[nodeId];
  if (decision === undefined) {
    return undefined;
  }
  const incomingEdgeIds = array.flatten(Object.values(decision.trafficIn));
  const matchingOutgoingEdgeIds = incomingEdgeIds.filter((edgeId) => {
    const edge = graphState.graph.edges[edgeId];
    return (
      isPathLookupEdgeData(edge) && edge.nextEdgeIds.includes(outgoingEdgeId)
    );
  });
  return matchingOutgoingEdgeIds;
};
